import { render, staticRenderFns } from "./DashView.vue?vue&type=template&id=682d136f"
import script from "./DashView.vue?vue&type=script&lang=js"
export * from "./DashView.vue?vue&type=script&lang=js"
import style0 from "./DashView.vue?vue&type=style&index=0&id=682d136f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports